
namespace RioERP.Reports {
    export class TeacherOutstandingColumns {
        static columnsKey = 'Reports.TeacherOutstanding';
    }
}